import React from 'react';

interface Props {
  className?: string;
}

const Pivot: React.FC<Props> = ({ className = '' }: Props) => (
  <svg
    className={className}
    fill="none"
    height="20"
    viewBox="0 0 20 21"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M10.75 0.5H10C4.47715 0.5 0 4.97715 0 10.5C0 16.0228 4.47715 20.5 10 20.5C15.5228 20.5 20 16.0228 20 10.5V9.74995H11.2993C11.1676 9.52225 10.9777 9.33239 10.75 9.20067V0.5ZM9.25 9.20067V2.53469C5.18341 2.91279 2 6.33463 2 10.5C2 14.9183 5.58172 18.5 10 18.5C14.1654 18.5 17.5872 15.3166 17.9653 11.2499H11.2994C11.04 11.6983 10.5552 12 10 12C9.17157 12 8.5 11.3284 8.5 10.5C8.5 9.94479 8.80165 9.46003 9.25 9.20067Z"
      fill="currentColor"
      fillRule="evenodd"
      id="Union"
    />
  </svg>
);

export default Pivot;
